<script>
	import model from "../../stores/modelStore";

	import confirmationPages from "./confirmationPages";
	import { projectSettings } from "../../config";

	import FormRow from "../../components/FormRow.svelte";
	import FormColumn from "../../components/FormColumn.svelte";
	import ReviewSectionHeader from "../../components/ReviewSectionHeader.svelte";

	import Disclaimer from "./components/Disclaimer.svelte";

	let disabled = true;

	document.title = `${projectSettings.classActionName} - Review`;
</script>

<section>
	<FormRow class="justify-content-center">
		<FormColumn>
			<h1 class="text-center">{@html projectSettings.classActionName}</h1>
		</FormColumn>
	</FormRow>

	<div class="confirmation">
		{#each confirmationPages as page}
			{#if (typeof page.hidePage === "function" && !page.hidePage($model)) || !page.hidePage}
				<ReviewSectionHeader heading={page.confirmationHeading}></ReviewSectionHeader>

				<svelte:component this={page.component} {...page} {disabled} />
			{/if}
		{/each}

		<Disclaimer />
	</div>
</section>
